import { API, AUTH, UBI_SERVICES } from '../utils/constants';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import axios, { AxiosRequestConfig } from 'axios';

const createRepository = (baseURL: string, options?: AxiosRequestConfig) =>
  axios.create({
    baseURL,
    ...options
  });

export const ubisoftServices = (options?: AxiosRequestConfig) =>
  createRepository(UBI_SERVICES.baseURL, {
    headers: {
      'Ubi-AppId': UBI_SERVICES.appId,
      Authorization: `ubi_v1 t=${AUTH.ticket}`
    },
    ...options
  });

export const api = (options?: AxiosRequestConfig) =>
  createRepository(API.baseURL, {
    headers: {
      'Ubi-SessionId': AUTH.sessionId,
      Authorization: `ubi_v1 t=${AUTH.ticket}`
    },
    ...options
  });
